// extracted by mini-css-extract-plugin
module.exports = {"settings":"styles_settings__3YE_p"};